"use strict";

var _regeneratorRuntime = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _jsonldContextParser = require("jsonld-context-parser");

var _dataModel = require("@rdfjs/data-model");

var _promiseUtils = require("./promiseUtils");
/**
 * Resolves property names of a path
 * to their corresponding IRIs through a JSON-LD context.
 */


var JSONLDResolver =
/*#__PURE__*/
function () {
  /**
   * Creates a new resolver for the given context(s).
   */
  function JSONLDResolver() {
    _classCallCheck(this, JSONLDResolver);

    (0, _defineProperty2.default)(this, "_context", Promise.resolve({}));
    this.extendContext.apply(this, arguments);
  }
  /**
   * The JSON-LD resolver supports all string properties.
   */


  _createClass(JSONLDResolver, [{
    key: "supports",
    value: function supports(property) {
      return typeof property === 'string';
    }
    /**
     * Resolves the property by extending the query path with it.
     */

  }, {
    key: "resolve",
    value: function resolve(property, pathData) {
      var _this = this;

      var predicate = {
        then: (0, _promiseUtils.getThen)(function () {
          return _this.expandProperty(property);
        })
      };
      return pathData.extendPath({
        property: property,
        predicate: predicate
      });
    }
    /**
     * Expands a JSON property key into a full IRI.
     */

  }, {
    key: "expandProperty",
    value: function () {
      var _expandProperty = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(property) {
        var expandedProperty;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // JavaScript requires keys containing colons to be quoted,
                // so prefixed names would need to written as path['foaf:knows'].
                // We thus allow writing path.foaf_knows or path.foaf$knows instead.
                property = property.replace(/^([a-z][a-z0-9]*)[_$]/i, '$1:'); // Expand the property to a full IRI

                _context.t0 = _jsonldContextParser.ContextParser;
                _context.t1 = property;
                _context.next = 5;
                return this._context;

              case 5:
                _context.t2 = _context.sent;
                expandedProperty = _context.t0.expandTerm.call(_context.t0, _context.t1, _context.t2, true);

                if (_jsonldContextParser.ContextParser.isValidIri(expandedProperty)) {
                  _context.next = 9;
                  break;
                }

                throw new Error("The JSON-LD context cannot expand the '".concat(property, "' property"));

              case 9:
                return _context.abrupt("return", (0, _dataModel.namedNode)(expandedProperty));

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function expandProperty(_x) {
        return _expandProperty.apply(this, arguments);
      }

      return expandProperty;
    }()
    /**
     * Extends the current JSON-LD context with the given context(s).
     */

  }, {
    key: "extendContext",
    value: function () {
      var _extendContext = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        var _len,
            contexts,
            _key,
            _args2 = arguments;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                for (_len = _args2.length, contexts = new Array(_len), _key = 0; _key < _len; _key++) {
                  contexts[_key] = _args2[_key];
                }

                _context2.next = 3;
                return this._context = this._context.then(function (currentContext) {
                  return new _jsonldContextParser.ContextParser().parse([currentContext].concat(contexts));
                });

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function extendContext() {
        return _extendContext.apply(this, arguments);
      }

      return extendContext;
    }()
  }]);

  return JSONLDResolver;
}();

exports.default = JSONLDResolver;